import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Features from "./components/Features";
import Channels from "./components/Channels";
import TalkSection from "./components/TalkSection";
import MoodSection from "./components/MoodSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import SubmitSection from "./components/SubmitSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <Features />
        <Channels />
        <TalkSection />
        <MoodSection />
        <FaqSection />
        <AboutSection />
        <SubmitSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}